export const truncate = (value, limit = 20, trail = '...') => {
  return value.length > limit ? value.substring(0, limit) + trail : value;
};
